import {HttpHandlerService} from "./HttpHandlerService";
import { StateService } from "@uirouter/angularjs";

export class AboutService extends HttpHandlerService {
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http,$q, $state);
    }
    getBaseUrl():string{
        return "about";
    }
    getAppVersion():ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),"AppVersion", {});
    }
    getDatabaseVersion():ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),"DatabaseVersion", {});
    }
    getLicenseSummary():ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),"LicenseSummary", {});
    }
}
